export default __webpack_public_path__ + "static/media/trbotkick.9db94947.mp3";